import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import DropshippedProductTableItem from './DropshippedProductTableItem';
import {
  IProductQueryData,
  IProductVars,
  useProductQuery,
} from '../../../../../graphql/query/product/useProductQuery';
import GraphQLTable from '../../../../components/_table/GraphQLTable';
import Helmet from '../../../../components/Helmet';
import { IProductSchema } from '../../../../../graphql/type/product';
import ProductLayout from '../../../../layout/Product';
import Context from '../../../../context';
import useRoutes from '../../../../components/_hook/useRoutes';

function DropshippedProductTable() {
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const { path } = useRoutes();
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<IProductSchema[]>([]);

  return (
    <>
      <Helmet
        title={`${t('dropshipped_product', { count: 2 })} | ${t('product')}`}
      />
      <GraphQLTable<IProductQueryData, IProductSchema, IProductVars>
        refreshKey={tableRefreshKey}
        select={`
              _id
              ordering
              company
              companyData {
                  _id
                  origin
                  slug
                  aka {
                      la
                      text
                  }
                  name {
                      la
                      text
                  }
              }
              sourceDropshippedProductCompanyID
              sourceDropshippedProductCompanyData {
                  _id
                  origin
                  slug
                  aka {
                      la
                      text
                  }
                  name {
                      la
                      text
                  }
              }
              name {
                  la
                  text
              }
              slug
              status 
              featured 
              prices {
                  final
                  currency
              }
              media {
                  images {
                      status 
                      filename
                      filename_small
      
                      filenameUrl
                      filenameSmallUrl
                  }
              }
              dropshipping {
                enable
              }
              updated {
                  time 
              }
              created {
                  time 
              }
       `}
        useQuery={useProductQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'name',
            label: t('name'),
            align: 'left',
          },
          {
            field: 'company',
            label: t('company'),
            align: 'center',
          },
          {
            field: 'image',
            label: t('image'),
            align: 'center',
          },
          {
            field: 'finalPrice',
            label: t('price'),
            align: 'center',
            sortable: true,
          },
          {
            field: 'status',
            label: t('status'),
            align: 'center',
          },
          {
            field: 'createdTime',
            label: t('created'),
            align: 'center',
            sortable: true,
          },
        ]}
        renderItem={(item) => (
          <DropshippedProductTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        useCheckbox
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        defaultFilterOptions={{
          companyId: company._id,
          isDropshippedProduct: true,
        }}
        searchFields={{
          _id: { label: t('id') },
          name: { label: t('name') },
        }}
        title={t('dropshipped_product')}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        noDataComponent={() => (
          <Grid container item xs={12} justifyContent="center">
            <Button
              color="primary"
              component={Link}
              variant="contained"
              to={path('product.dropshipped.request', {
                companyID: company._id,
              })}
            >
              {t('request_for_dropship_now')}
            </Button>
          </Grid>
        )}
        itemKey="_id"
      />
    </>
  );
}

export default () => <ProductLayout main={<DropshippedProductTable />} />;
